import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import Input from "components/ui/Input";

const TradeModal = ({ holding, action, onClose, onConfirm }) => {
  const [qty, setQty] = useState("");
  const [orderType, setOrderType] = useState("market");
  const [limitPrice, setLimitPrice] = useState(holding?.currentPrice?.toFixed(2) || "");

  if (!holding) return null;

  const qtyNum = parseInt(qty) || 0;
  const price = orderType === "market" ? holding?.currentPrice : parseFloat(limitPrice) || holding?.currentPrice;
  const total = qtyNum * price;
  const isSell = action === "sell";
  const maxQty = isSell ? holding?.qty : 99999;

  const handleConfirm = () => {
    if (qtyNum <= 0 || qtyNum > maxQty) return;
    onConfirm({ holding, action, qty: qtyNum, price, orderType, total });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.85)" }}>
      <div className="w-full max-w-md rounded-xl border border-border p-6" style={{ background: "var(--color-card)" }}>
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-md flex items-center justify-center text-sm font-heading font-bold" style={{ background: `${holding?.color}20`, color: holding?.color }}>
              {holding?.ticker?.slice(0, 2)}
            </div>
            <div>
              <h3 className="font-heading text-base font-semibold text-foreground">{isSell ? "Sell" : "Buy"} {holding?.ticker}</h3>
              <p className="font-caption text-xs text-muted-foreground">Current: ${holding?.currentPrice?.toFixed(2)}</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-md flex items-center justify-center hover:bg-primary/10 transition-colors">
            <Icon name="X" size={16} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {["market", "limit"]?.map(t => (
            <button key={t} onClick={() => setOrderType(t)} className={`flex-1 py-2 rounded-md font-caption text-xs capitalize transition-all duration-200 border ${orderType === t ? "border-primary text-primary" : "border-border text-muted-foreground hover:border-primary/50"}`} style={orderType === t ? { background: "rgba(0,217,255,0.1)" } : {}}>
              {t} Order
            </button>
          ))}
        </div>

        <div className="space-y-3 mb-5">
          <Input label="Quantity" type="number" placeholder={`Max: ${maxQty?.toLocaleString()}`} value={qty} onChange={e => setQty(e?.target?.value)} min={1} max={maxQty} />
          {orderType === "limit" && (
            <Input label="Limit Price ($)" type="number" placeholder="0.00" value={limitPrice} onChange={e => setLimitPrice(e?.target?.value)} min={0.01} step={0.01} />
          )}
        </div>

        <div className="rounded-lg p-3 mb-5 space-y-2" style={{ background: "var(--color-muted)" }}>
          {[["Shares", qtyNum?.toLocaleString()], ["Price", `$${price?.toFixed(2)}`], ["Estimated Total", `$${total?.toLocaleString("en-US", { minimumFractionDigits: 2 })}`]]?.map(([l, v]) => (
            <div key={l} className="flex justify-between text-xs">
              <span className="font-caption text-muted-foreground">{l}</span>
              <span className="font-data text-foreground font-medium">{v}</span>
            </div>
          ))}
        </div>

        <div className="flex gap-3">
          <Button variant="outline" fullWidth onClick={onClose}>Cancel</Button>
          <Button variant={isSell ? "destructive" : "default"} fullWidth onClick={handleConfirm} disabled={qtyNum <= 0 || qtyNum > maxQty}>
            {isSell ? "Sell" : "Buy"} {holding?.ticker}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TradeModal;